import { t } from '@if/core/i18n'
import { EPaymentPlan } from '@if/core/types'
import * as yup from '@if/core/yup'
import { EProtectionPlanCoverage } from '@src/types/CalculatorEstimateDto'
import { CreditRatingBands, ETerms, ETermsList, PersonalLoanCalculatorConstants } from '@src/types/Constants'

const { MIN_AMOUNT } = PersonalLoanCalculatorConstants

export const PersonalLoanCalculatorSchema = yup.object().shape({
  // Max depends on the merchant's service category (Medicard vs. regular — see
  // `$maxLoanValue` set by CalculatorForm via setValidationContext), not a fixed constant.
  amountRequested: yup
    .integer()
    .min(MIN_AMOUNT, () => t('common.errors.minimumAmount', { min: MIN_AMOUNT }))
    .max(yup.ref('$maxLoanValue'), ({ max }) => t('common.errors.maximumAmount', { max }))
    .required(),

  // Banner users pick which subsidiary to calculate for; a form field so the
  // picker can be a ControlledAutocomplete. Optional — non-banner users never see it.
  selectedMerchantId: yup.text(),

  paymentPlanId: yup.mixed<EPaymentPlan>().required(),
  term: yup.mixed<ETerms>().oneOf(ETermsList, () => t('common.errors.invalidTerm')),
  // The selected band, identified by its lower bound — the rate can repeat across
  // bands (an agreement covering the whole scale), so it can't identify the selection.
  // The rate itself is resolved from the band at submit time, not stored on the form.
  creditRatingMinErs: yup.number().required().default(CreditRatingBands[0].minErs),
  // Reveal toggle for the business-fee rate; the rate itself isn't a form value.
  // Off by default — the merchant opts into seeing it.
  showBusinessFee: yup.boolean().default(false),
  // Joint prices at the with-co-applicant rate, so coverage changes the payment.
  protectionPlan: yup.mixed<EProtectionPlanCoverage>().required().default(EProtectionPlanCoverage.None),
})

export type PersonalLoanCalculatorSchemaType = yup.InferSubmit<typeof PersonalLoanCalculatorSchema>
